import React from "react";
import { Redirect } from "react-router-dom";
// User profile
import UserProfile from "../pages/Authentication/UserProfile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Users from "pages/Users";
import TwostepVerification from "pages/Authentication/TwostepVerification";
import Slider from "pages/Sliders";
import SocialPage from "pages/Social";
import ProductsPage from "pages/Products";
import AboutUsPage from "pages/AboutUs";
import CategoriesPage from "pages/Categories";
import ContactUsPage from "pages/ContactUs";
import NewsPage from "pages/News";
import UserComment from "pages/UserComment";
import FlagsPage from "pages/Flags";
import BrandsPage from "pages/Brands";
import CatalogPage from "pages/Catalogs";
import EmailPage from "pages/email";

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/products", component: ProductsPage },
  { path: "/sliders", component: Slider },
  { path: "/about-us", component: AboutUsPage },
  { path: "/contact-us", component: ContactUsPage },
  { path: "/social", component: SocialPage },
  { path: "/categories", component: CategoriesPage },
  { path: "/news", component: NewsPage },
  { path: "/user-comment", component: UserComment },
  { path: "/flags", component: FlagsPage },
  { path: "/brands", component: BrandsPage },
  { path: "/catalogs", component: CatalogPage },
  { path: "/email", component: EmailPage },

  //profile
  { path: "/users", component: Users },
  // { path: "/profile", component: UserProfile },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },

  { path: "/two-step-verification", component: TwostepVerification },
];

export { authProtectedRoutes, publicRoutes };
